import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React, { useState, useRef } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
 import AuthenticationLayout from '../components/AuthenticationLayout';
 import BasicLayout from '../components/BasicLayout';
 import { getApiHeader } from 'utlis/commonfunctions';
 import axios from 'axios';
 import Alert from '@mui/material/Alert';
import { Box, Button, TextField, Typography, Grid, Card, CardActionArea, Backdrop, CircularProgress } from '@mui/material';
import PageLayout from "examples/LayoutContainers/PageLayout";
import ReCAPTCHA from 'react-google-recaptcha';
import SimIcon from 'examples/Icons/SimIcon';
import swal from 'sweetalert';

 const SERVER_URL = process.env.REACT_APP_API_URL;

const ContactUs = () => {
  const recaptchaRef = useRef(null);
  const[loading,setLoading]=useState(false)
  const[error,setError]=useState(null)
  const[sucess,setSucess]=useState(null)
  const [formData,setFormData]=useState({
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  message: "",
})

 


  const handleChange = (event) => {
    const { name, value } = event.target;
  
    if (name === "phone") {
      // Accept only numbers with a maximum length of 10
      if (/^\d{0,10}$/.test(value)) {
        setFormData({ ...formData, [name]: value });
      }
    } else if (name === "last_name" || name === "first_name") {
      // Accept only alphabetic characters and spaces, with a maximum length of 50
      if (/^[a-zA-Z ]{0,50}$/.test(value)) {
        setFormData({ ...formData, [name]: value });
      }
    } else {
      // For all other fields, allow any value
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };
  



 const handleSubmit= async(event)=>{
    try {
      event.preventDefault()
      const token = await recaptchaRef.current.executeAsync();
          
      const payload = {
        first_name:formData.first_name,
        last_name:formData.last_name,
        email:formData.email,
        phone:formData.phone,
        message:formData.message,
        recaptcha:token,
      }     

      setLoading(true)
       const headers= await getApiHeader()
       const response = await axios.post(`${SERVER_URL}contact-us `,payload,{headers:headers})
       console.log("responseeeeeeeeee",response)
        if(response.status===200){
          setLoading(false)
          setFormData({
            first_name: "",
            last_name: "",
            email: "",
            phone: "",
            message: ""
          });
          // setSucess(response.data.message)
          handleSucessMessage()
          swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
            button: "Close"
          });

          if (token) {
            // Make your API call or form submission with the token
            console.log("reCAPTCHA Token:", token);
          }
      
          // Reset reCAPTCHA
          recaptchaRef.current.reset();
        }
    } catch (error) {
       setLoading(false)
       console.log("error",error)
         const message=error?.response?.data?.message
       swal({
        title: "error",
        text:message,
        icon: "success",
        button: "Close"
      });
      
    }
 }


 const handleSucessMessage=()=>{
  setTimeout(()=>{
    setSucess(null)

  },9000)
}



  return (
          <>
        <PageLayout background="white">  
           {loading && (
      <Backdrop
          open={true}
          style={{
              color: "#fff",
              zIndex: 9999,
          }}
      >
          <CircularProgress color="inherit" />
      </Backdrop>
  )}
  
        
    <div className='contactus-wrapper'>
    <div className="container py-5">
      <h2 className="text-center mb-4" style={{color:"#C11D6C"}}>Contact Us</h2>
      <div className="row">
        {/* Contact Information Section */}
        <div className="col-md-5  text-white p-4 rounded contact-us-side-box">
          <h4>Contact Us</h4>
          <p>We're here to help, Connect with us.</p>

          <p>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path d="M6.62 10.79a15.054 15.054 0 006.59 6.59l1.7-1.7a1.003 1.003 0 011.08-.21c1.12.46 2.33.71 3.57.71.55 0 1 .45 1 1v3.5c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1H6c.55 0 1 .45 1 1 0 1.24.25 2.45.71 3.57.13.33.05.71-.22 1.08l-1.7 1.7z" />
  </svg>
  <strong> Direct Line Number</strong>: (02) 7259 7777
</p>

<p>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path d="M12 8c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1zm0-6c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-.5-8H11c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h.5v.5c0 .28.22.5.5.5s.5-.22.5-.5V15h.5c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1h-.5v-.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V10z" />
  </svg>
  <strong> Service Hours</strong>: 9am to 6pm (7 days)
</p>


          <div className="text-center my-3">
                  <button className="btn contact-whatsApp" style={{textColor:"white"}}>
                    <i className="bi bi-whatsapp"  style={{textColor:"white"}}></i> Scan the QR Code to Message us on WhatsApp
                  </button>
                </div>
          <div className="d-flex justify-content-center">
            <img src="https://mailerv2.telsim.com.au/qr-code/whatsapp-qr-code.png" alt="QR Code" className="img-fluid" style={{ width: '150px',height:"150px" }} />
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="col-md-7 mt-4 mt-md-0 px-5">
          <h5>We would love to hear from you</h5>

          <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="firstName" className="form-label contact-us-label">First Name <span class="astrix-color">*</span></label>
                        <input type="text" className="form-control" id="firstName" name="first_name" autocomplete="off" value={formData.first_name} placeholder="First Name" required onChange={handleChange} />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="lastName" className="form-label contact-us-label">Last Name <span class="astrix-color">*</span></label>
                        <input type="text" className="form-control" id="lastName" placeholder="Last Name" autocomplete="off" name='last_name' value={formData.last_name} required onChange={handleChange} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="email" className="form-label contact-us-label">Your Email <span class="astrix-color">*</span></label>
                        <input type="email" className="form-control" id="email" placeholder="Your Email"  maxLength={50} autocomplete="off" name="email" required value={formData.email} onChange={handleChange} />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="phone" className="form-label contact-us-label">Phone <span class="astrix-color">*</span></label>
                        <input type="tel" className="form-control" id="phone" placeholder="Phone" name="phone" autocomplete="off" required maxLength={10} value={formData.phone} onChange={handleChange} />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="message" className="form-label contact-us-label">Your Message <span class="astrix-color">*</span></label>
                      <textarea className="form-control" id="message" rows="4" placeholder="Your Message"  maxLength={200} autocomplete="off" name="message" value={formData.message} required onChange={handleChange}></textarea>
                    </div>
                    <div className="text-end">
                      <button type="submit" className="recharge_button">Submit</button>
                    </div>

         <ReCAPTCHA
        sitekey="6Ld9WHsqAAAAAHR_7WpUEHppp6pZ0whCtqv05T-M" 
        size="invisible"
        ref={recaptchaRef}
      />
                  </form>
        </div>
      </div>
    </div>   
    {error && (
        <Alert variant="outlined" severity="error" className="mb-4">
          {error}
        </Alert>
      )}
     
     {sucess && (
        <Alert variant="outlined" severity="success" className="mb-4">
          {sucess}
        </Alert>
      )}
      </div>
  
    </PageLayout>

    </>
  );
};



export default ContactUs